import React from 'react';
import useModal from '../../hooks/useModal';
import { Beneficiary } from '../../types';
import Button from '../Button';
import AddEditBeneficiaryModal from './AddEditBeneficiaryModal';

const newOrExistingBeneficiary: Beneficiary = {
  beneficiaryType: '',
  relationship: '',
  firstName: '',
  middleName: '',
  lastName: '',
  ssn: '',
  dob: '',
  title: '',
  suffix: '',
  gender: '',
  // sameAddress: 'false',
  // address1: '',
  // address2: '',
  // city: '',
  // state: '',
  // zipCode: '',
  entityName: '',
  entityId: '',
  trustDate: '',
};

function AddEditBeneficiaryDemo() {
  const [showModal, handleShow, handleClose] = useModal();
  const [beneficiary] = React.useState<Beneficiary>(newOrExistingBeneficiary);

  const handleSubmit = (data: any) => {
    console.log('submit', data);
  };

  return (
    <section>
      <h4> Add new beneficiary</h4>
      <Button variant="primary" onClick={handleShow}>
        Add New / Edit Benericiary
      </Button>
      <AddEditBeneficiaryModal
        title="Add New Beneficiary"
        showModal={showModal}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        existingBeneficiary={beneficiary}
      />
    </section>
  );
}

export default AddEditBeneficiaryDemo;
